import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core'
import { AssessmentGroupDto } from '../../../models/flip/assessment-group-dto'

@Component({
  selector: 'app-flip-assessment-side-card',
  templateUrl: './flip-assessment-side-card.component.html',
  styleUrls: ['./flip-assessment-side-card.component.scss'],
  standalone: false,
})
export class FlipAssessmentSideCardComponent implements AfterViewInit {
  @Input() flipAssessmentGroups: AssessmentGroupDto[]
  @Input() scrollIndex: number
  @ViewChild('scrollContainer') scrollContainer: ElementRef | undefined
  @Output() editClicked: EventEmitter<string> = new EventEmitter<string>()

  ngAfterViewInit(): void {
    if (this.scrollIndex) {
      this.scrollToItem(this.scrollIndex)
    }
  }

  scrollToItem(index: number): void {
    if (this.scrollContainer?.nativeElement) {
      const container = this.scrollContainer.nativeElement
      const selectedElement =
        container?.getElementsByClassName('item-container')[index]

      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'end',
        })
      }
    }
  }

  handleEditClicked(index: string) {
    this.editClicked.emit(index)
  }
}
